var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBallot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 15.375H32.25C33.4875 15.375 34.5 14.3625 34.5 13.125C34.5 11.8875 33.4875 10.875 32.25 10.875H25.5C24.2625 10.875 23.25 11.8875 23.25 13.125C23.25 14.3625 24.2625 15.375 25.5 15.375ZM25.5 31.125H32.25C33.4875 31.125 34.5 30.1125 34.5 28.875C34.5 27.6375 33.4875 26.625 32.25 26.625H25.5C24.2625 26.625 23.25 27.6375 23.25 28.875C23.25 30.1125 24.2625 31.125 25.5 31.125ZM36.75 41.25H5.25C2.775 41.25 0.75 39.225 0.75 36.75V5.25C0.75 2.775 2.775 0.75 5.25 0.75H36.75C39.225 0.75 41.25 2.775 41.25 5.25V36.75C41.25 39.225 39.225 41.25 36.75 41.25ZM9.75 18.75H16.5C17.7375 18.75 18.75 17.7375 18.75 16.5V9.75C18.75 8.5125 17.7375 7.5 16.5 7.5H9.75C8.5125 7.5 7.5 8.5125 7.5 9.75V16.5C7.5 17.7375 8.5125 18.75 9.75 18.75ZM9.75 9.75H16.5V16.5H9.75V9.75ZM9.75 34.5H16.5C17.7375 34.5 18.75 33.4875 18.75 32.25V25.5C18.75 24.2625 17.7375 23.25 16.5 23.25H9.75C8.5125 23.25 7.5 24.2625 7.5 25.5V32.25C7.5 33.4875 8.5125 34.5 9.75 34.5ZM9.75 25.5H16.5V32.25H9.75V25.5Z",
    fill: "#FCBE40"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBallot);
export default __webpack_public_path__ + "static/media/icon-ballot.4e98c7cd.svg";
export { ForwardRef as ReactComponent };